import initialRecommendationDecisionCompleted from "./editors";
import initialDecisionsEditors from "./initial-decisions-editors";
import timeNone from './time-none';

export default [...timeNone,...initialRecommendationDecisionCompleted, ...initialDecisionsEditors];